<template>
  <v-card class="back" style="height: 480px">
    <v-layout column fill-height>
      <v-toolbar dark color="secondary" dense flat>
        <v-toolbar-title>
          <span class="body-2 text-uppercase">{{$t('customize notification statuses')}} {{$t('for')}} {{user}}</span>
        </v-toolbar-title>
      </v-toolbar>

      <scroll-area>
        <template slot="body">
          <v-layout column fill-height justify-start pl-3>
            <v-checkbox v-for="(status, index) in Object.keys(details)" :key="index" hide-details :label="$t(status)" 
            :data-testid="$options.name + '__checkbox__' + status" 
            v-model="details[status]"></v-checkbox>
          </v-layout>
        </template>

        <template slot="footer">
          <v-layout fill-height>
            <v-flex xs2>
            </v-flex>
            <v-layout fill-height justify-end>
              <v-btn dark small :data-testid="$options.name + '__btn__' + 'save'" @click="() => saveDetails()" color="primary">{{$t('save')}}</v-btn>
              <v-btn dark small outline :data-testid="$options.name + '__btn__' + 'cancel'" @click="$emit('close')" color="blacktext">{{$t('cancel')}}</v-btn>
            </v-layout>
          </v-layout>
        </template>
      </scroll-area>

    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы для деталей доступа
interface AccessDetails {
  alarm: boolean
  damage: boolean
  warning: boolean
  unknown: boolean
  ok: boolean
  [key: string]: boolean
}

// Тип для пропсов
interface AccessDetailsProps {
  user: string
  rule: string
  access_details: AccessDetails
}

// Тип для ответа при сохранении
interface SaveDetailsResponse {
  user: string
  rule: string
  access_details: AccessDetails
}

export default Vue.extend({
  name: 'ACCESS_DETAILS_CARD',

  components: {
    scrollArea,
  },

  props: {
    user: {
      type: String,
      default: 'undefined',
    },
    rule: {
      type: String,
      default: 'undefined',
    },
    access_details: {
      type: Object as () => AccessDetails,
      default: () => ({
        alarm: true,
        damage: true,
        warning: true,
        unknown: true,
        ok: true
      })
    }
  },

  data(): {
    details: AccessDetails
  } {
    return {
      details: {
        alarm: true,
        damage: true,
        warning: true,
        unknown: true,
        ok: true
      },
    }
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.reset()
      if (Object.keys(this.access_details).length) {
        this.details = { ...this.access_details }
      }
    },

    saveDetails(): void {
      const resp: SaveDetailsResponse = {
        user: this.user,
        rule: this.rule,
        access_details: this.details
      }
      this.$emit('changeAccessDetails', resp)
    },

    reset(): void {
      this.details = {
        alarm: true,
        damage: true,
        warning: true,
        unknown: true,
        ok: true
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
